import { PasswordMaxDateValidationStatus } from 'common/enum/password-max-date-validation-status'
import theme from 'presentation/styles/theme'
import styled, { css } from 'styled-components'

type SituationStatus = {
  status: PasswordMaxDateValidationStatus
}

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
`

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 16px;
`

export const CardFooter = styled.div<{
  color?: keyof typeof theme.ds.colors
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .tresh-icon {
    path {
      fill: ${({ theme }) => theme.ds.colors.primary400};
    }
    &:hover {
      path {
        fill: ${({ theme }) => theme.ds.colors.primary500};
      }
    }
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;

  > button {
    flex: 1;
    height: 40px;
  }
`

export const TrashIconInList = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: -32px;
  size: 24px;

  .tresh-icon {
    path {
      fill: ${({ theme }) => theme.ds.colors.primary400};
    }
    &:hover {
      path {
        fill: ${({ theme }) => theme.ds.colors.primary500};
      }
    }
  }
`

export const BadgeCounter = styled.div<{
  color?: keyof typeof theme.ds.colors
}>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({ theme, color = 'terciary400' }) =>
    theme.ds.colors[color]};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
`

export const AlertIconWrapper = styled.span<SituationStatus>`
  ${({ theme, status }) => css`
    display: flex;
    svg {
      width: 16px;
      height: 16px;
      margin-right: 4px;
      path {
        fill: ${status === PasswordMaxDateValidationStatus.EXPIRED
          ? theme.ds.colors.danger500
          : theme.ds.colors.attention500};
      }
    }
  `}
`

export const BoxPendencies = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .pendency-icon {
    margin-right: 8px;

    path {
      fill: ${({ theme }) => theme.ds.colors.terciary400};
    }
  }
`
